import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import { FaPaperPlane} from 'react-icons/fa'

class Track extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.ref = React.createRef();
      this.state = {

      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };
    }

    componentDidMount() {
        if (this.props.track !== null) {
          const child = this.props.track.attach();
          console.log(child)
          this.ref.current.classList.add(this.props.track.kind);
          this.ref.current.appendChild(child)
        }
    }




    render() {
      console.log(document.getElementsByTagName("video"))
      // if(document.getElementsByTagName("video")){
      //   document.getElementsByTagName("video").style.width = '1000px'
      //   document.getElementsByTagName("video").style.height = '600px'
      // }
      console.log(this.ref)
      return (
        <div ref={this.ref} style={{width: '100%', height: '100%'}}>
        </div> 
      );
    }

  };
  
  export default withCookies(Track);